export const styled = {
    actionBarContainer: {
        display: "flex",
        alignItems: "center",
        gap: 3,
        mb: 2,
        p: 2,
        flexWrap: "wrap",
        position: "sticky",
        top: "-12px",
        marginTop: 0,
        zIndex: 100,
        backgroundColor: "#fff",
        borderBottom: "1px solid",
        borderColor: "divider",
    },

    categorySelect: {
        width: 250,
    },

    selectInput: {
        fontSize: "0.9rem",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    clearButton: {
        mr: 0.5,
    },

    selectText: {
        fontSize: "0.9rem",
    },

    placeholderText: {
        fontSize: "0.9rem",
        opacity: 0.6,
    },

    menuItemText: {
        fontSize: "0.8rem",
    },

    viewTypeButton: {
        textTransform: "none",
    },
};
